import type { DocumentType } from '../../../js/api';

/**
 * The document types `audience` may choose in a generic picker (the Documents tab's
 * upload dialog, the legacy-file convert dialog): uploadable by that audience and not
 * entry-backed. An entry-backed type (license, certification, immunization) only exists
 * behind its structured entry — the kind, exemption, state and number live there — so it
 * is added from the entry's own tab, never picked here. `pinnedSlug` keeps the one type a
 * caller has already fixed (an in-context upload, a credential file's locked type).
 */
export const pickableUploadTypes = (
  types: readonly DocumentType[],
  audience: string,
  pinnedSlug?: string | null
): DocumentType[] =>
  types.filter(
    (dt) =>
      (dt.allowed_audience_upload ?? []).includes(audience) &&
      (!dt.is_entry_backed || dt.slug === pinnedSlug)
  );
